import React from "react";
import { Stats } from "@usereactify/search";

export type StatsProps = {
  resultStats: {
    hidden: number;
    numberOfResults?: number;
    promoted: number;
    time: number;
  };
};

const RenderProductStats = (props: StatsProps) => {
  const productCount = props?.resultStats?.numberOfResults || 0;
  const label = productCount > 1 ? " products" : " product";
  return (
    <div data-testid="product-stats-label" className="text-hint text-primary">
      {productCount > 0 ? productCount + label : null}
    </div>
  );
};

export const FilterSectionProductStats = () => {
  return <Stats render={RenderProductStats} />;
};
